import { createAction, props } from '@ngrx/store'
import { PaymentGatewayLog } from './gateway-log.model'

export const LoadPaymentGatewayLog = createAction('[Payment Gateway Log] Load', props<{ id: string }>())
export const LoadPaymentGatewayLogComplete = createAction(
  '[Payment Gateway Log] Load Complete',
  props<{ id: string; log: PaymentGatewayLog[] }>()
)
